import {useTranslation} from 'next-i18next';
import NavBarBrand from '@components/NavBarBrand';
import Empty from '@components/Empty';
import Container from '@components/Container';
import Lottie from 'react-lottie-player';
import buildConfig from 'build-config.json';

interface EmptyGroupsProps {
	createGroup: () => void;
	locale: string;
}

const EmptyGroups = ({createGroup, locale}: EmptyGroupsProps) => {
	const {t} = useTranslation();

	return (
		<>
			<NavBarBrand locale={locale} />
			<Container>
				<Empty>
					<Lottie
						loop
						path={`${buildConfig.host_assets_ssl}/animations/Shaker_EmptyState_In.json`}
						play
						style={{
							width: '200px',
						}}
					/>
					<Empty.Title>
						{t('musictogetheremptystate_text_createyourgroup_web')}
					</Empty.Title>
					<Empty.Description>
						{t('musictogetheremptystate_text_createyourgroupdescription_web')}
					</Empty.Description>
					<Empty.Button onClick={() => createGroup()}>
						{t('musictogether_action_createagroup_web')}
					</Empty.Button>
				</Empty>
			</Container>
		</>
	);
};

export default EmptyGroups;
